import React from 'react';
import PropTypes from 'prop-types';
import AppsBanner from '../../components/AppsBanner';
import Categories from '../../components/Categories';
import RecommendedRow from '../../components/RecommendedRow';
import fireBatchedImpressions from '../../lib/BatchImpressions';
import StaffPicks from '../../components/StaffPicks';
import loadable from '@loadable/component';

const QuickLinksFragment = loadable(() =>
  import('../../components/QuickLinksFragment')
);

class Main extends React.Component {
  componentDidMount = () => {
    const links = this.getImpressionLinks();
    const { toolTileProps: { app: { csrf = '' } = {} } = {} } = this.props;
    fireBatchedImpressions(links, csrf);
  };

  getImpressionLinks = () => {
    const links = [];
    const {
      structuredPSData: {
        content: { PSImpressionUrl = '' },
        categories = []
      } = {}
    } = this.props;
    links.push(PSImpressionUrl);
    categories.forEach(({ content = {}, featured = [] }) => {
      links.push(content.PSImpressionUrl);
      featured.forEach(({ PSImpressionUrl = '' }) => {
        links.push(PSImpressionUrl);
      });
    });
    return links;
  };

  renderYourRecommendations = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      defaultRecommended = []
    } = this.props;
    const { flatPSData: { recommended = [] } = {} } = toolTileProps;
    return (
      <div id="appcenter-categories">
        <RecommendedRow
          content={recommended[0]}
          featured={defaultRecommended}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      </div>
    );
  };

  renderStaffPicks = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      structuredPSData,
      experimentation = {}
    } = this.props;
    const { flatPSData: { staffPick = [] } = {} } = toolTileProps;
    const { staffPickDisplayed = [] } = structuredPSData;

    if (
      !staffPickDisplayed.length ||
      !experimentation.staffPickExp ||
      !staffPick[0] ||
      !staffPick[0].categoryTitle
    )
      return null;
    return (
      <StaffPicks
        fptiImpression={fptiImpression}
        fptiClick={fptiClick}
        content={staffPick[0]}
        toolTileProps={toolTileProps}
        {...this.props}
      />
    );
  };
  render() {
    const {
      structuredPSData: { content = {}, categories = [] } = {},
      fptiClick,
      fptiImpression,
      toolTileProps = {}
    } = this.props;
    const isLoggedIn = toolTileProps.app?.context?.user?.isLoggedIn;
    const {
      flatPSData: { isRecommendedCategoryEligible } = {}
    } = toolTileProps;
    return (
      <div id="appcenter-main">
        <AppsBanner content={content} />
        {isLoggedIn &&
          isRecommendedCategoryEligible &&
          this.renderYourRecommendations()}
        {this.renderStaffPicks()}
        {toolTileProps.app.deviceInfo.isDesktop && isLoggedIn && (
          <QuickLinksFragment />
        )}
        <Categories
          categories={categories}
          viewAllText={content.viewDetails}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      </div>
    );
  }
}

Main.displayName = 'main';

Main.propTypes = {
  categories: PropTypes.array,
  ps: PropTypes.object,
  structuredPSData: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  defaultRecommended: PropTypes.array,
  experimentation: PropTypes.object
};

export default Main;
